import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/drama/${drama.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
        <img
          src={drama.image}
          alt={drama.title}
          title={`${drama.title} - 萝卜影视电视剧全集`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            {drama.rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-1 rounded-md bg-foreground-900/70 text-background-50 text-xs">
            {drama.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
            <i className="ri-play-fill"></i>
            立即观看
          </span>
        </div>
      </div>
      <h3 className="font-heading text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {drama.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{drama.year}</span>
        <span>·</span>
        <span>{drama.updateInfo}</span>
      </div>
    </Link>
  );
}